const Header = () => {
  const today = new Date();
  const dateOptions: Intl.DateTimeFormatOptions = { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  const formattedDate = today.toLocaleDateString('en-GB', dateOptions);

  // Get greeting based on time of day
  const hour = today.getHours();
  let greeting = "Good morning";
  if (hour >= 12 && hour < 17) {
    greeting = "Good afternoon";
  } else if (hour >= 17) {
    greeting = "Good evening";
  }

  return (
    <header className="mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <div>
          <h1 className="text-2xl font-semibold text-foreground">
            Glossa <span className="font-normal">Aesthetics</span>
          </h1>
          <p className="text-muted-foreground text-sm mt-1">{greeting}! Here's your clinic overview.</p>
        </div>
        <div className="text-sm text-muted-foreground md:text-right">
          <span className="font-medium text-[#704AAF]">{formattedDate}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
